import { AppBar, Toolbar, useMediaQuery, useTheme } from '@mui/material';
import { HamburgerButton } from './buttons/HamburgerButton';
import { useState } from 'react';
import { useStyles } from './styles/MainBar.styles';
import { UserAvatar } from './UserAvatar';
import { ProfilePopover } from './ProfilePopover';
import { MainBarHeader } from './MainBarHeader';
import { MobileDrawer } from './MobileDrawer';
import { TimezonePicker } from './TimezonePicker';
import { Link } from 'react-router-dom';
import { AppRoutes } from '@consts/routes';

export const MainBar = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [avatarAnchor, setAvatarAnchor] = useState(null);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <AppBar position='fixed' className={classes.appBar}>
                <Toolbar className={classes.appToolbar}>
                    <HamburgerButton handleToggle={() => setSidebarOpen(!sidebarOpen)} />

                    {!isMobile && (
                    <Link to={AppRoutes.Insights}>
                        <img className={classes.logo} src='/logo.png' />
                    </Link>
                    )}

                    <MainBarHeader mobile={false} />

                    <TimezonePicker />

                    <UserAvatar toggled={false} handleToggleProfile={(event) => setAvatarAnchor(event.currentTarget)} />
                </Toolbar>
            </AppBar>

            <MobileDrawer sidebarOpen={sidebarOpen} handleToggle={() => setSidebarOpen(!sidebarOpen)} />

            <ProfilePopover anchorEl={avatarAnchor} onClose={() => setAvatarAnchor(null)} />
        </div>
    );
};
